<template>
  <div class="rating">
    <div class="rating__stars">
      <div class="rating__stars-outline">
        <svg
          v-for="(index, key) in maxRating"
          class="rating__star"
          aria-hidden="true"
          :key="key"
          v-once
        >
          <use
            class="use"
            xlink:href="#star-outline"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ></use>
        </svg>
      </div>

      <div
        class="rating__stars-filled"
        :style="{ width: fillStars(rating.average) }"
      >
        <svg
          v-for="(index, key) in maxRating"
          class="rating__star"
          aria-hidden="true"
          :key="key"
          v-once
        >
          <use
            class="use"
            xlink:href="#star-filled"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          ></use>
        </svg>
      </div>
    </div>
    <div class="rating__score">
      {{ rating.average }}/{{ maxRating }} {{ rating.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-card-rating',
  props: {
    rating: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxRating: 5,
    };
  },

  methods: {
    fillStars(average) {
      const starPercentage = (average / this.maxRating) * 100;
      return average > 0 ? `${starPercentage}%` : '0%';
    },
  },
};
</script>
